export const interventionKeys = {
  all: ['interventions'] as const,
  lists: () => [...interventionKeys.all, 'list'] as const,
  list: (orgId?: string, filters?: unknown) =>
    [...interventionKeys.lists(), orgId ?? 'all', filters] as const,
  details: () => [...interventionKeys.all, 'detail'] as const,
  detail: (id: string) => [...interventionKeys.details(), id] as const,
  documents: (interventionId: string) =>
    [...interventionKeys.detail(interventionId), 'documents'] as const,
  filterCounts: (technicianId?: string, crossOrg?: boolean) =>
    [...interventionKeys.all, 'filter-counts', technicianId, crossOrg] as const,
  matchingTechnicians: (interventionId: string) =>
    [
      ...interventionKeys.detail(interventionId),
      'matching-technicians',
    ] as const,
  rejectedTechnicians: (interventionId: string) =>
    [
      ...interventionKeys.detail(interventionId),
      'rejected-technicians',
    ] as const,
  counts: (interventionId: string) =>
    [...interventionKeys.detail(interventionId), 'counts'] as const,
  full: (interventionId: string) =>
    [...interventionKeys.detail(interventionId), 'full'] as const,
  reports: (interventionId: string) =>
    [...interventionKeys.detail(interventionId), 'reports'] as const,
  technicianActions: (interventionId: string) =>
    [...interventionKeys.detail(interventionId), 'technician-actions'] as const,
  calendar: (orgId?: string, start?: string, end?: string) =>
    [...interventionKeys.all, 'calendar', orgId ?? 'all', start, end] as const,
}
